import React, { useEffect, useState } from "react";
import { useRawInitData } from "@telegram-apps/sdk-react";

import { useAuth } from "@/store/authStore";
import { loginWithTelegram } from "@/api/auth";
import { fetchMe } from "@/api/users";
import { LoadingScreen } from "@/components/LoadingScreen/LoadingScreen";

export const TelegramAuthProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const rawInitData = useRawInitData();
  const { setInitData, accessToken, setMe } = useAuth();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setInitData(rawInitData ?? null);
  }, [rawInitData, setInitData]);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        if (rawInitData && !accessToken) {
          await loginWithTelegram();
        }

        if (accessToken) {
          const me = await fetchMe();
          if (!cancelled) setMe(me);
        } else if (!cancelled) setMe(null);
      } catch {
        if (!cancelled) setMe(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    if (rawInitData === undefined) return;

    run();

    return () => {
      cancelled = true;
    };
  }, [rawInitData, accessToken, setMe]);

  if (loading) return <LoadingScreen />;

  return <>{children}</>;
};
